import { useEffect } from 'react';
import { getImageUrl } from '../../utils/imageUrlHelper';

const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const DEFAULT_FAVICON_URL = `${publicUrl}/favicon/favicon.svg`;

const getMimeType = (url) => {
  if (!url) {
    return 'image/svg+xml';
  }

  const lowerUrl = url.toLowerCase();
  if (lowerUrl.endsWith('.svg')) {
    return 'image/svg+xml';
  }
  if (lowerUrl.endsWith('.ico')) {
    return 'image/x-icon';
  }

  return 'image/png';
};

const DynamicFavicon = () => {
  useEffect(() => {
    const applyFavicon = (faviconUrl) => {
      const href = faviconUrl ? getImageUrl(faviconUrl) : DEFAULT_FAVICON_URL;
      const mime = getMimeType(href);
      const links = document.querySelectorAll("link[rel*='icon']");

      if (links.length === 0) {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = mime;
        link.href = href;
        document.head.appendChild(link);
        return;
      }

      links.forEach((link) => {
        link.type = mime;
        link.href = href;
      });
    };

    const handleFaviconUpdate = (event) => applyFavicon(event.detail?.faviconUrl || null);
    applyFavicon(null);
    window.addEventListener('faviconUpdated', handleFaviconUpdate);
    return () => window.removeEventListener('faviconUpdated', handleFaviconUpdate);
  }, []);

  return null;
};

export default DynamicFavicon;

